import { render, staticRenderFns } from "./PostLists.vue?vue&type=template&id=34396bf9&scoped=true&"
import script from "./PostLists.vue?vue&type=script&lang=js&"
export * from "./PostLists.vue?vue&type=script&lang=js&"
import style0 from "./PostLists.vue?vue&type=style&index=0&id=34396bf9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34396bf9",
  null
  
)

export default component.exports